import { apiClient } from '@/services/api'
import endpoints from '@/services/endpoints'

export default {
  set: {
    token(token) {
      if (token) {
        //applying token
        apiClient.defaults.headers.common['Authorization'] = `Token ${token}`
      } else {
        //deleting the token from header
        delete apiClient.defaults.headers.common['Authorization']
      }
    },
  },

  get: {
    authHeaders() {
      return apiClient.defaults.headers.common['Authorization']
    },
  },

  login(credentials) {
    return apiClient.post(endpoints.authentication.login(), credentials)
  },

  logout() {
    return apiClient.post(endpoints.authentication.logout())
  },

  async passwordReset(newPasswordData) {
    try {
      const newPassword = await apiClient.post(
        endpoints.authentication.passwordReset(newPasswordData.uid, newPasswordData.token),
        newPasswordData
      )
      return newPassword
    } catch (error) {
      return error
    }
  },
}
